import React from "react";

function PaymentPolicies() {
  return (
    <div className="policy-container">
      <div className="content">
        <h2>Payment Policy</h2>
        <p>
          <br />
          <h3>Introduction</h3>
          This document sets out Techvanto Academy’s policy in relation to the
          collection of fees and charges payable to Techvanto Academy by current
          and former users for the provision of its services and offerings.
        </p>
        <p>
          <br />
          <h3>Purpose</h3>
          The purpose of this policy is to ensure that Techvanto Academy
          collects the amounts that are due to it. The policy also aims to
          fulfil the following objectives:
          <ul>
            <li>
              Explaining in an open, transparent and accessible way how
              Techvanto Academy will treat users who have outstanding debt owed
              to Techvanto Academy
            </li>
            <li>
              Demonstrating what actions users can take to mitigate any steps
              likely to be taken by Techvanto Academy to recover outstanding
              debt.
            </li>
            <li>
              Applying a user debt policy that is “firm but fair"; encourages
              all users to pay in good time, but has the flexibility to
              recognise and respond appropriately when this is not possible
              because of genuine difficulty.
            </li>
          </ul>
        </p>

        <p>
          <br />
          <h3>Support to Users</h3>
          In applying this policy, Techvanto Academy will at all times seek to
          be sympathetic to individual users financial circumstances. However,
          for Techvanto Academy to do so, users must engage in dialogue with
          Techvanto Academy if they are experiencing financial difficulties.
          <br />
          Users experiencing difficulties in paying any fees and charges should
          seek financial advice at the earliest opportunity by contacting
          info@techvanto.com.
        </p>

        <p>
          <br />
          <h3>Communication with users</h3>
          Formal documents such as invoices, bills and reminders will be sent
          electronically to the users email address which had been entered at
          the time of registration. Users must access and use this account
          regularly. As the main objective is to make contact with the student,
          Techvanto Academy may also contact users:
          <ul>
            <li>Using any phone number provided by the user</li>
            <li>Using any alternative email address provided by the user</li>
            <li>By letter to the home and /or address provided by the user</li>
          </ul>
        </p>
        <p>
          <br />
          <h3>Methods of Payment</h3>
          Techvanto Academy offers a wide range of payment methods to allow
          users to pay fees and charges quickly and securely. These methods
          include debit cards, credit cards, UPI, Paytm and Net Banking.
          <br />
          Techvanto does not retain any of the credit card details or any other
          information that is limited to payment collection by RBI and has
          collaborated with payment gateways to pay for the services. You
          consent to abide by the terms of such a payment service by using a
          third-party payment processor, such as Razorpay, PhonePe, GPay and
          Paytm. Techvanto will not be liable if any other information is
          processed by Techvanto's third-party payment processor and the user
          will authorise that information to be stored by a third party at your
          absolute discretion. Any damages or losses suffered by the user
          through the use of such details shall be purely a loss incurred by him
          and Techvanto shall assume no liability for such losses or be
          responsible in any manner or for any compensation or reimbursement of
          such losses. The user accepts and is entitled to cover and indemnify
          Techvanto from all claims, commitments, damages, expenses and claims
          that exist or arise from misuse or other purposes due to the use of
          the online payment mechanism.
          <br />
          Techvanto Academy shall not be liable for any repayment resulting from
          online payments delays or where the balance is withdrawn from the
          save/actual account and not transferred to the Techvanto company
          account before completing the transaction. Users would need to contact
          their bank for the same.
        </p>
        <p>
          <br />
          <h3>Fees</h3>
          Students become liable for the payment of the full enrollment fee on
          enrolment to a course, workshop or training program.
          <br />
          Fees can be paid in full, in advance or at enrollment; users who do so
          will qualify for a prompt payment discount. This discount shall be
          applicable during checkout.
          <br />
          At the time of enrollment, the learner shall make the full payment for
          enrollment in a course. However, by payment of the registration fee
          (specified on the corresponding product pages), you can register for a
          course, workshop or training program too. Within 1 week of
          registration, you can pay the rest of the fee (Program Fee minus the
          registration fee). If you do not make a payment during this time,
          there will be extra costs. If you can not pay the rest of the
          programme fee within 1 week from the payment of the initial
          registration fee, your registration will be cancelled. You could be
          given more time to make the outstanding payment in extraordinary
          circumstances.
        </p>
        <p>
          <br />
          <h3>Withdrawal from a Course</h3>
          In the event of a user having to withdraw before the end of their
          programme, the student shall not be eligible for a refund under any
          circumstance from Techvanto Academy. For missed sessions/deadlines or
          discontinuation, we shall not provide refunds.
        </p>
        <p>
          <br />
          <h3>Other fees and charges</h3>
          Payment for the use of other Techvanto Academy facilities or provision
          of resources must be paid in accordance with the agreed payment terms
          and conditions. These include (but are not limited to) fines, late
          payment charges, etc.
        </p>
        <p>
          <br />
          <h3>Non-Payment of Fees and Charges</h3>
          By payment of the registration fee (specified on the corresponding
          product pages), you can register for a course, workshop or training
          program too. Within 1 week of registration, you can pay the rest of
          the fee (Program Fee minus the registration fee). If you do not make a
          payment during this time, there will be extra costs. If you can not
          pay the rest of the programme fee within 1 week from the payment of
          the initial registration fee, your registration will be cancelled.
          <br />
          Where there are outstanding fees and charges from users, Techvanto
          Academy will instigate debt recovery processes. These will be
          triggered, a) where an invoice for fees or charges is not settled by
          the due date, or b) where payment in accordance with an agreed
          installment plan is not received.
          <br />
          This procedure seeks to encourage payment of outstanding student debts
          by facilitating dialogue leading to agreement on the resolution of
          debts: but also to take such action against student debtors as may be
          necessary to ensure equitable treatment of all users required to pay
          fees and charges.
        </p>
        <p>
          <br />
          <h3>
            Collection Processes to be followed for Late or Non Payment of fees
            and charges
          </h3>
          The focus of debt control procedures will be to enter into a dialogue
          as soon as possible with users experiencing financial difficulty to
          lead to a mutually satisfactory resolution of the debt situation.
          Users experiencing difficulties in paying any fees and charges should
          seek help at the earliest opportunity by contacting
          info@techvanto.com. If a user fails to enter into such a dialogue
          and/or fails to honour agreements to pay, sanctions may be applied.
          <br />
          Proportionate action to enforce settlement of debt for outstanding
          fees and charges will be taken against current and former users who
          have failed to engage to find a solution to any outstanding debt
          issues, or who have failed to honour agreements to pay.
        </p>
        <p>
          <br />
          <h3>Tuition Fees and academic related charges</h3>
          The management will get in touch with the user if there is no response
          to us reaching out at the first instance, sanctions will be applied.
          However Techvanto Academy will not impose sanctions whilst good-faith
          discussions are going on with the student concerned.
          <br />
          The team will endeavour to make contact with the student to ensure
          that there are no welfare issues underlying the student's failure to
          engage with Techvanto Academy.
          <br />
          Where the team has made every reasonable effort to obtain payment and
          where it is apparent that the student is unlikely to pay the amount
          owed, an email or letter will be issued advising that the student may
          be excluded from Techvanto Academy and asking him/her to contact us as
          a matter of urgency.
          <br />
          Techvanto Academy will issue a final e-mail to the user notifying them
          that the final step for exclusion from the course, workshop or
          training program will be put in place.
          <br />
          Details of their outstanding account will be passed to a commercial
          debt collection agency to obtain the payment and they will be liable
          for all costs incurred in raising this action.
        </p>
      </div>
    </div>
  );
}

export default PaymentPolicies;
